import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import ServiceContent from '../../components/ServiceComponent/ServiceContent';
import { useParams } from 'react-router-dom';
import { serviceContentList } from '../../axios/axios';
import ServiceFormRegister from '../../components/popup/serviceFormRegister/ServiceFormRegister';
import BlogComp from '../../components/moreBlog/BlogComp';
import { baseVar } from '../../Global/GlobalVariable';
import { Helmet } from 'react-helmet';
import { blogListnewD } from '../../axios/axios';
import './service.css';

function Service() {
	const [data, setData] = useState([]);
	const { id } = useParams();
	const [blogData, setBlogData] = useState([]);

	let serviceApi;

	var urlEndPoint = window.location.href.split('/');

	var newId = urlEndPoint[urlEndPoint.length - 1];

	const apiRender = React.useMemo(() => ({ newIdRender: id }), [id]);

	const dataContent = async () => {
		if (id) {
			await serviceContentList({ id }).then((res) => setData(res.data));
			await blogListnewD().then((res) => setBlogData(res.data));
		}

		serviceApi = false;
	};

	useEffect(() => {
		dataContent();

		return () => {
			serviceApi = true;
		};
	}, [apiRender]);

	return (
		<>
			<Helmet>
				<meta name='robots' content='index, follow' />
				<title>{data?.seo_details?.service_title}</title>
				<meta name='description' content={data?.seo_details?.meta_desc} />
				<meta name='author' content='Eauditor Office' />
				<meta property='og:title' content={data?.seo_details?.service_title} />
				<meta
					property='og:description'
					content={data?.seo_details?.meta_desc}
				/>
				<meta property='og:image' content={data?.seo_details?.ogImagePath} />
				<link rel='canonical' href={window.location.href} />
			</Helmet>
			<div>
				<div className='fade_in container pt-4 mt-4 pt-lg-5 font_family'>
					<div className=' container-fluid'>
						<Row className=''>
							<div class='breadcrumbs py-md-4 py-4 mt-0 mb-xl-4 mt-xl-5 mt-md-4 mb-md-3'>
								<nav class='dark_background'>
									<ol>
										<li>
											<a className='bd_pageName' href={baseVar} title='Home'>
												Home
											</a>
										</li>
										<li className='bd_breadCrumb_mainHead text-start'>
											{data?.service_list?.service_name}
										</li>
									</ol>
								</nav>
							</div>
							<Col sm={12}>
								<div>
									<h1 className=' s1_c1_h1 mb-4 mb-lg-5 text-start'>
										{data.service_title}
									</h1>
								</div>
							</Col>
						</Row>
						{data?.service_title ? (
							<>
								{newId && <ServiceContent data={data} id={newId} />}
								<ServiceFormRegister />
								<hr className='my-md-5' />

								{data.service_title && (
									<div>
										{' '}
										<p className='fade_in c1_c1_h1 mb-3 mb-lg-4 text-start'>
											Blogs to read
										</p>
										<BlogComp data={blogData} />
									</div>
								)}
							</>
						) : (
							<h1>Loading...</h1>
						)}
					</div>
				</div>
			</div>
		</>
	);
}

export default Service;
